import { useQuery } from "@tanstack/react-query";
import { listAllTherapistPatientsResponse } from "../../patient";

/** The therapist's caseload (first 200), to pick or filter a payment's patient. */
export const usePatientsForPayment = (therapistId: string | undefined) =>
    useQuery({
        queryKey: ["patients-for-payment", therapistId],
        queryFn: async () => {
            const { data } = await listAllTherapistPatientsResponse(therapistId as string);
            return data;
        },
        enabled: Boolean(therapistId),
    });
